import React from 'react';
import { Link } from 'react-router-dom';


const PrivacyPolicy = () => {
    return (
        <div className="container-fluid p-2">
            <h3 className="text-center">Privacy Policy</h3>

            <p>Welcome to OSIF (One Shift in Full)
                We are committed to protecting your privacy and ensuring the secure management of your information.This Privacy Policy describes how we handle the information collected through our platform and services provided to our client, the JSPL Group of Companies.</p>

            <h4>1. Information We Collect</h4>
            <p>We may collect information required for the seamless operation and management of shift activities within your organization, including:</p>
            <ul >
                <li ><strong>Operational Data:</strong> Information about planned activities in the form of 3TSOP during shifts.</li>
                <li ><strong>User Information:</strong> Names, roles, and usage patterns related to the application.</li>
                <li ><strong>Device Information:</strong> Technical details to ensure platform compatibility and functionality.</li>
            </ul>

            <h4>2. Data Usage</h4>
            <p>The information we collect is used strictly for:</p>
            <ul>
                <li>Efficient shift management and reporting.</li>
                <li>Providing and improving OSIF functionalities.</li>
                <li>Supporting troubleshooting and maintenance.</li>
            </ul>

            <h4>3. Data Sharing Policy</h4>
            <p>We do not share user data with any third party.</p>
            <p>All data collected is securely stored and used solely for the operational requirements of the JSPL Group of Companies.</p>

            <h4>4. Data Security</h4>
            <p>We implement robust security measures to protect your information.</p>
            <p>Although we take every precaution, no system is entirely immune to threats.</p>

            <h4>5. User Rights</h4>
            <p>As a user of OSIF, you have the right to:</p>
            <ul>
                <li>Access and review information related to your activities.</li>
                <li>Request corrections if any inaccuracies are found.</li>
                <li>Seek assistance for technical concerns.</li>
            </ul>

            <h4>6. Children&#39;s Privacy</h4>
            <p>OSIF is a professional tool not intended for use by individuals under the age of 18.</p>

            <h4>7. Changes to This Policy</h4>
            <p>We reserve the right to update this policy from time to time.</p>
            <p>Any changes will be communicated appropriately.</p>

            <h4>8. Contact Us</h4>
            <p>For any concerns or questions regarding this Privacy Policy, please contact:</p>
            <p className='fw-bold'>PBOPlus Consulting Pvt. Ltd.</p>
            <p> <Link to="mailto:plot@pboplus.com" className='text-decoration-underline'>plot@pboplus.com</Link></p>
        </div>
    );
};

export default PrivacyPolicy;
